import { Layout, Menu, Button, Space } from 'antd'
import {
  DashboardOutlined,
  FileTextOutlined,
  TeamOutlined,
  BarChartOutlined,
  PartitionOutlined,
  SettingOutlined,
  BellOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Link, useLocation, Outlet } from 'react-router-dom'

const { Header, Content } = Layout

export function AppLayout() {
  const location = useLocation()

  const getSelectedKey = () => {
    const path = location.pathname
    if (path === '/' || path === '/dashboard') return '1'
    if (path === '/assessments') return '2'
    if (path === '/workspaces') return '3'
    if (path === '/reports') return '4'
    if (path === '/pipelines') return '5'
    if (path === '/settings') return '6'
    return '1'
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Top Header */}
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#1890ff',
          padding: '0 24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
            <BarChartOutlined style={{ fontSize: 24, color: 'white' }} />
            <span style={{ color: 'white', fontSize: 18, fontWeight: 600 }}>Smart Assessments</span>
          </Link>
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[getSelectedKey()]}
            style={{ flex: 1, minWidth: 0, background: 'transparent', borderBottom: 'none' }}
            items={[
              { key: '1', label: <Link to="/dashboard">Dashboard</Link>, icon: <DashboardOutlined /> },
              { key: '2', label: <Link to="/assessments">Assessments</Link>, icon: <FileTextOutlined /> },
              { key: '3', label: <Link to="/workspaces">Workspaces</Link>, icon: <TeamOutlined /> },
              { key: '4', label: <Link to="/reports">Reports</Link>, icon: <BarChartOutlined /> },
              { key: '5', label: <Link to="/pipelines">Pipelines</Link>, icon: <PartitionOutlined /> },
              { key: '6', label: <Link to="/settings">Settings</Link>, icon: <SettingOutlined /> },
            ]}
          />
        </div>
        <Space>
          <Button type="text" icon={<BellOutlined />} style={{ color: 'white' }} />
          <Button type="text" icon={<UserOutlined />} style={{ color: 'white' }}>
            Ricardo
          </Button>
        </Space>
      </Header>

      {/* Main Content */}
      <Content style={{ padding: '24px 48px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: 1400, margin: '0 auto' }}>
          <Outlet />
        </div>
      </Content>
    </Layout>
  )
}

